import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-249cef75"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "lecture-box"
};
const _hoisted_2 = {
  class: "module-top"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  class: "lecture-timeline"
};
const _hoisted_6 = {
  class: "lecture-item"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "lecture-info"
};
const _hoisted_9 = {
  class: "lecture-teacher"
};
export default {
  props: {
    menu: Object
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    const $utils = inject('$utils');
    const lectureList = ref([]);

    const formatTime = ({
      start_time,
      end_time
    }) => {
      if ($utils.dateAreOnSameDay(start_time, end_time)) {
        return $utils.formatDate(start_time, 'M/DD') + ' ' + $utils.formatDate(start_time, 'HH:mm') + '-' + $utils.formatDate(end_time, 'HH:mm');
      } else {
        return $utils.formatDate(start_time, 'M/DD HH:mm') + ' 至 ' + $utils.formatDate(end_time, 'M/DD HH:mm');
      }
    };

    const handleDetail = id => {
      window.open(`/lectureDetail.html?menuId=${props.menu.menu_id}&name=${props.menu.module_name}&id=${id}`);
    };

    const getHomeLecture = async () => {
      const list = await $http.getHomeLecture({
        menu_id: props.menu.menu_id
      });
      lectureList.value = list ? list.slice(0, 3) : [];
    };

    getHomeLecture();
    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_timeline_item = _resolveComponent("el-timeline-item");

      const _component_el_timeline = _resolveComponent("el-timeline");

      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.menu.module_name), 1), _createElementVNode("a", {
        href: `/lectureList.html?menuId=${__props.menu.menu_id}&name=${__props.menu.module_name}`,
        class: "right"
      }, "全部>", 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_timeline, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lectureList.value, item => {
          return _openBlock(), _createBlock(_component_el_timeline_item, {
            hollow: true,
            type: "primary",
            timestamp: formatTime(item),
            placement: "top",
            key: item.id
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
              class: "lecture-title",
              onClick: $event => handleDetail(item.id)
            }, _toDisplayString(item.live_name), 9, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_tag, {
              class: "lecture-type"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.classify_name), 1)]),
              _: 2
            }, 1024), _createElementVNode("span", _hoisted_9, "主讲人: " + _toDisplayString(item.teacher_name), 1)])])]),
            _: 2
          }, 1032, ["timestamp"]);
        }), 128))]),
        _: 1
      })])]);
    };
  }

};